/**
 * Minoría de edad del interviniente.
 *
 * El backend la resuelve SIEMPRE desde la fecha de nacimiento (UserIdentity.IsMinor: menor ⟺
 * Birthday > hoy − 18 años) y no guarda ningún flag. El formulario, en cambio, arrastraba
 * `formData.isMinor`, que solo se asigna al arrancar (flujo de alta de menor) y al cargar el detalle,
 * donde el mapper lo deriva también de `hasProofOfMinorGuardian`. Ese flag no caduca nunca, así que
 * una vez el interviniente tiene justificante de tutela se queda pegado a true incluso años después
 * de cumplir los 18. De ahí que la edad haya que calcularla aquí, desde la fecha.
 */

// Edad a partir de la cual el interviniente deja de ser menor.
const AdultAgeYears = 18;

function toStartOfDay(value: Date): Date
{
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
}

/**
 * Fecha de nacimiento límite: quien nació ese día o antes ya es mayor de edad.
 * Se conserva el mismo cálculo que ya usaba el formulario (setFullYear) para no mover el límite
 * vigente de sitio con este cambio.
 */
function getAdultBirthdayCutoff(today: Date): Date
{
    const todayStart = toStartOfDay(today);
    const cutoff = new Date(todayStart);
    cutoff.setFullYear(todayStart.getFullYear() - AdultAgeYears);
    return cutoff;
}

/** Menor de edad según su fecha de nacimiento. Sin fecha no se puede afirmar: se asume mayor, igual que el backend. */
export function isMinorByBirthday(birthday: Date | null | undefined, today: Date = new Date()): boolean
{
    if(!birthday)
    {
        return false;
    }
    return toStartOfDay(birthday).getTime() > getAdultBirthdayCutoff(today).getTime();
}
